module.exports = __webpack_public_path__ + "post-listing-block-3-overlay@2x-3bS3D4-.png";